import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/pages/login/Login'
// import Home from '@/components/pages/home/Home'
import TransactionList from '@/components/pages/transactions/TransactionList'
import ValidationListNew from '@/components/pages/validations/ValidationListNew'
import CreateTransaction from '@/components/pages/transactions/CreateTransaction'
import TransactionDetails from '@/components/pages/transactions/TransactionDetails'
import CustomerServiceHomeNew from '@/components/pages/customerservice/CustomerServiceHomeNew'
import ValidationDetailsNew from '@/components/pages/validations/ValidationDetailsNew'
import CustomerServiceDetailsNew from '@/components/pages/customerservice/CustomerServiceDetailsNew'
import DefaultContainer from '@/components/containers/DefaultContainer'
import EcommerceList from '@/components/pages/ecommerces/EcommerceList'
import EcommerceNew from '@/components/pages/ecommerces/EcommerceNew'
// import ChargeDashboard from '@/components/pages/charge/ChargeDashboard'
// import CancellationsList from '@/components/pages/cancellations/CancellationsList'
// import ProtocolsList from '@/components/pages/protocols/ProtocolsList'
// import ContactsList from '@/components/pages/contacts/ContactsList'
// import Settings from '@/components/pages/settings/Settings'
// import Campaigns from '@/components/pages/campaigns/Campaigns'
import CancellationsInfo from '@/components/pages/cancellations/CancellationsInfo'
import OrderList from '@/components/pages/order/OrderList'
import OrderValidation from '@/components/pages/order/OrderValidation'
// const Flags = () => import('@/views/icons/Flags')
// const FontAwesome = () => import('@/views/icons/FontAwesome')
// const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')

// const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
/*
import NewInterface from '@/components/pages/newInterface/NewInterface' // temp import
import NewInterface2 from '@/components/pages/newInterface/NewInterface2' // temp import
import NewInterface3 from '@/components/pages/newInterface/NewInterface3' // temp import
*/
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')

Vue.use(Router)

export default Vue.router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/orders',
      name: 'Home',
      component: DefaultContainer,
      children: [
        /*
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {auth: true}
        },
        */
        /*
        {
          path: 'financeiro',
          name: 'Financeiro',
          component: Financeiro,
          meta: {auth: true}
        },
        */
        {
          path: '/nova-transacao',
          name: 'CreateTransaction',
          component: CreateTransaction,
          meta: {auth: true}
        },
        {
          path: 'validations',
          name: 'ValidationListNew',
          component: ValidationListNew,
          meta: { auth: true, label: 'Lista de validações' },
          children: [
            {
              path: '/validations/:txid',
              name: 'ValidationDetailsNew',
              component: ValidationDetailsNew,
              meta: {auth: true, label: 'Validação'}
            }
          ]
        },
        {
          path: 'orders',
          name: 'OrderList',
          component: OrderList,
          meta: { auth: true, label: 'Lista de pedidos' },
          children: [
            {
              path: '/order-validation/:txid',
              name: 'OrderValidation',
              component: OrderValidation,
              meta: {auth: true, label: 'Detalhes do Pedido'}
            }
          ]
        },
        {
          path: 'list',
          name: 'TransactionList',
          component: TransactionList,
          meta: {auth: true}
        },
        {
          path: '/tx/:txid',
          name: 'TransactionDetails',
          component: TransactionDetails,
          meta: {auth: true}
        },
        {
          path: 'customerService',
          name: 'CustomerServiceNew',
          component: CustomerServiceHomeNew,
          meta: { auth: true, label: 'Lista de clientes' },
          children: [
            {
              path: '/customerService/:txid',
              name: 'CustomerServiceDetailsNew',
              component: CustomerServiceDetailsNew,
              meta: {auth: true, label: 'Detalhes do cliente'}
            }
          ]
        },
        {
          path: 'ecommerces',
          name: 'e-commerce list',
          component: EcommerceList,
          meta: {auth: true, label: 'Lista de e-commerces'}
        },
        {
          path: 'ecommercesNew',
          name: 'new e-commerce',
          component: EcommerceNew,
          meta: {auth: true, label: 'Comerciante'}
        },
        {
          path: '/ecommercesNew/:ecommerceId',
          name: 'new e-commerce edit',
          component: EcommerceNew,
          meta: {auth: true}
        },
        /*
        {
          path: 'charge',
          name: 'Cobrança',
          component: ChargeDashboard,
          meta: {auth: true}
        },
        */
        /*
        {
          path: 'cancellations',
          name: 'Cancelamentos',
          component: CancellationsList,
          meta: {auth: true}
        },
        */
        {
          path: 'cancellations/:transactionId',
          name: 'info-cancelamentos',
          component: CancellationsInfo,
          meta: {auth: true}
        }
        /*
        {
          path: 'whatsapp-protocols',
          name: 'Protocols list',
          component: ProtocolsList,
          meta: {auth: true, label: 'Lista de protocolos'}
        },
        */
        /*
        {
          path: 'whatsapp-contacts',
          name: 'Contacts list',
          component: ContactsList,
          meta: {auth: true, label: 'Contatos do whatsapp'}
        },
        */
        /*
        { // Temp file
          path: 'new-interface',
          name: 'New Interface',
          component: NewInterface,
          meta: {auth: true}
        },
        { // Temp file
          path: 'new-interface-2',
          name: 'New Interface 2',
          component: NewInterface2,
          meta: {auth: true}
        },
        { // Temp file
          path: 'new-interface-3',
          name: 'New Interface 3',
          component: NewInterface3,
          meta: {auth: true}
        },
        */
        /*
        {
          path: 'settings',
          name: 'Settings',
          component: Settings,
          meta: {auth: true},
          children: [
            {
              path: '/campaigns',
              name: 'Campaigns',
              component: Campaigns,
              meta: {auth: true}
            }
          ]
        }
        */
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: {auth: false}
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js